import Vue from 'vue';
import App from './App'
import router from './router'
import store from './store'


import './utils/flexible.js'
import '@/styles/main.scss'
import '@/styles/index.css'
import tool from "./utils/tool";
Vue.use(tool);

import Element, {
  Message
} from 'element-ui'

import {
  initSocket
} from "@/utils/socket.js";
Vue.prototype.$socket = initSocket();

// 全屏滚动 vue-fullpage.js
// import 'vue-fullpage.js/dist/style.css'
import 'fullpage.js/vendors/scrolloverflow'
import VueFullPage from 'vue-fullpage.js'
Vue.use(VueFullPage)
new Vue({
  // el: '#app',
  router,
  store,
  render: h => h(App),
}).$mount('#app')
